"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const axios_1 = __importDefault(require("axios"));
const Crop_1 = __importDefault(require("@becrop/abstract/Models/Crop"));
class CropListServices {
    constructor() {
        this.data = [];
    }
    async fetchCrops() {
        try {
            const { data } = await axios_1.default.get('/crops/list');
            this.data = data.map((cropItem) => new Crop_1.default({
                id: cropItem.id,
                name: cropItem.crop_name,
                color: cropItem.color,
                icon: cropItem.logo_name
            }));
        }
        catch (error) {
            console.error('Error fetching crops:', error.message || error);
        }
    }
}
exports.default = CropListServices;
